/**
 * Preloads all images used as CSS background-image URLs so the browser
 * caches them before they're first displayed. This eliminates the flash
 * of missing images when monsters, floor tiles, walls, or treasure first render.
 *
 * Uses new Image() to trigger eager download. Called early in index.tsx.
 */

const assetPaths: string[] = [
  // Demon SVGs (monster1-5)
  require("../assets/demons/character-evil-halloween-horror-monster-svgrepo-com.svg"),
  require("../assets/demons/mummy-svgrepo-com.svg"),
  require("../assets/demons/frankenstein-svgrepo-com.svg"),
  require("../assets/demons/monster-svgrepo-com.svg"),
  require("../assets/demons/evil-halloween-hand-svgrepo-com.svg"),

  // DALL·E monster PNGs (monster6-16)
  require("../assets/dalle/DALL·E 2023-02-16 09.29.29 - goblin with an axe pixel art edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 09.29.39 - goblin with an axe pixel art edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 09.29.53 - goblin with an axe pixel art edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 09.30.47 - skeleton with a sword pixel art edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 09.32.01 - goblin covered in blood pixel art white background edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 09.33.08 - spooky threatening ghost pixel art white background edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 09.34.02 - violent horned demon pixel art white background edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 09.37.04 - angry devil pixel art white background edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 10.38.03 - minotaur pixel art white background edit.png"),
  require("../assets/dalle/DALL·E 2023-02-16 10.42.09 - angry zombie pixel art white background.png"),
  require("../assets/dalle/DALL·E 2023-02-16 10.42.22 - angry zombie pixel art white background edit.png"),

  // Board elements
  require("../assets/largeorangediamond-svgrepo-com.svg"),    // floor tile
  require("../assets/brick-wall-wall-svgrepo-com.svg"),       // wall
  require("../assets/treasure-chest-svgrepo-com.svg"),        // treasure / center
];

export function preloadImages(): void {
  for (const src of assetPaths) {
    const img = new Image();
    img.src = src;
  }
}
